<template>
    <div class="menu">
        <el-divider></el-divider>
        <div v-if="userInfo.roleName == roleNameParent" class="parent">
          <div class="menu-item cursor-pointer" @click="onStudyRecordCount">學生表現<br />Learning Performance</div>
          <el-divider></el-divider>
            <div class="menu-item cursor-pointer" @click="onStudentProfile">學生帳戶<br />Student Account</div>
            <el-divider></el-divider>
            <div class="menu-item cursor-pointer" @click="onParentProfile">家長資料<br />Parent Info.</div>
            <el-divider></el-divider>
            <div class="menu-item cursor-pointer" @click="onPurchaseHistory">訂閱付費紀錄<br />Subscribe Record</div>
            <el-divider></el-divider>
            <div class="menu-item cursor-pointer" @click="onContact">聯絡我們<br />Contact Us</div>
<!--            <el-divider></el-divider>-->
<!--            <div class="menu-item cursor-pointer" @click="onRefund">退款政策<br />Refund Policy</div>-->
            <el-divider></el-divider>
            <div class="menu-item cursor-pointer" @click="onPrivacy">私隱聲明<br />Privacy Policy Statement</div>
            <el-divider></el-divider>
            <div class="menu-item cursor-pointer" @click="onDisclaimer">使用條款<br />Terms of Service</div>
            <el-divider></el-divider>
            <div v-show="$route.path == '/payment'">
                <div class="menu-item cursor-pointer" v-if="$store.getters.language !== languageZhTc && home" @click="onLangText(languageZhTc)" style="line-height: 2.25rem;">將語言更改為繁體</div>
                <div class="menu-item cursor-pointer" v-else-if="home" @click="onLangText(languageEn)" style="line-height: 2.25rem;">Change language to EN</div>
                <el-divider></el-divider>
            </div>
        </div>
        <div v-else>
            <div class="menu-user">
                <button
                    class="cursor-pointer"
                    v-if="home && userInfo.roleName != roleNameStudent"
                    @click="onSubscribe"
                    style="background: #fcc03a; box-shadow: 0px 0.5rem 0 #c28c00; border: none; border-radius: 5.5rem; padding: 0.5rem 1.5rem; margin-bottom: 0.5rem; font-size: 1rem"
                >
                    {{ $t("other.order") }}
                </button>
                <div class="cursor-pointer" style="font-size: 1.2rem" v-if="userInfo.roleName != roleNameParent && userInfo.roleName != roleNameStudent" @click="onAwesomeUser">
                    <img class="userInfo" src="@/assets/images/login.png" />
                    {{ $t("other.login") }}
                </div>
                <div class="cursor-pointer" style="font-size: 1.2rem" v-else @click="onLogOut">
                    {{ $t("dashboard.logOut") }}
                </div>
            </div>
            <el-divider></el-divider>
            <div class="menu-item cursor-pointer" @click="onAbout">{{ $t("other.about") }}</div>
            <el-divider></el-divider>
            <div class="menu-item cursor-pointer" @click="onPlatform">{{ $t("other.platform") }}</div>
            <el-divider></el-divider>
            <div class="menu-item cursor-pointer" @click="onFaq">{{ $t("other.faq") }}</div>
            <el-divider></el-divider>
            <div class="menu-item cursor-pointer" @click="onContact">{{ $t("other.contact") }}</div>
            <el-divider></el-divider>
<!--            <div class="menu-item cursor-pointer" @click="onSitemap">{{ $t("other.sitemap") }}</div>-->
<!--            <el-divider></el-divider>-->
<!--            <div class="menu-item cursor-pointer" @click="onRefund">{{ $t("other.refund") }}</div>-->
<!--            <el-divider></el-divider>-->
<!--            <div class="menu-item cursor-pointer" @click="onPrivacy">{{ $t("other.privacy") }}</div>-->
<!--            <el-divider></el-divider>-->
<!--            <div class="menu-item cursor-pointer" @click="onDisclaimer">{{ $t("other.disclaimer") }}</div>-->
<!--            <el-divider></el-divider>-->
            <div class="menu-item cursor-pointer" v-if="$store.getters.language !== languageZhTc && home" @click="onLangText(languageZhTc)">將語言更改為繁體</div>
            <div class="menu-item cursor-pointer" v-else-if="home" @click="onLangText(languageEn)">Change language to EN</div>
            <el-divider></el-divider>
        </div>
    </div>
</template>

<script>
import { logout } from "@/api/security";
import { removeToken, removeAll } from "@/utils/auth";
export default {
    props: {
        home: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            carts: [],
        };
    },
    watch: {
        "$store.getters.language": {
            handler(v) {
                this.$i18n.locale = v;
            },
            deep: true,
        },
    },
    methods: {
        onStudyRecordCount() {
          this.$router.push({ path: "/studyRecordCount" });
          this.$emit("closeDrawer");
        },
        onStudentProfile() {
            this.$router.push({ path: "/studentProfile" });
            this.$emit("closeDrawer");
        },
        onParentProfile() {
            this.$router.push({ path: "/parentProfile" });
            this.$emit("closeDrawer");
        },
        onPurchaseHistory() {
            this.$router.push({ path: "/purchaseHistory" });
            this.$emit("closeDrawer");
        },
        onAbout() {
            this.$router.push({ name: "about" });
            this.$emit("closeDrawer");
        },
        onPlatform() {
            this.$router.push({ name: "platform" });
            this.$emit("closeDrawer");
        },
        onFaq() {
            this.$router.push({ name: "faq" });
            this.$emit("closeDrawer");
        },
        onContact() {
            this.$router.push({ name: "contact" });
            this.$emit("closeDrawer");
        },
        onSitemap() {
            this.$router.push({ name: "sitemap" });
            this.$emit("closeDrawer");
        },
        onRefund() {
            this.$router.push({ name: "refund" });
            this.$emit("closeDrawer");
        },
        onPrivacy() {
            this.$router.push({ name: "privacy" });
            this.$emit("closeDrawer");
        },
        onDisclaimer() {
            this.$router.push({ name: "disclaimer" });
            this.$emit("closeDrawer");
        },
        onLangText(v) {
            this.$i18n.locale = v;
            this.$store.dispatch("setLanguage", v);
        },
        onSubscribe() {
            this.$router.push({ name: "cart" });
            this.$emit("closeDrawer");
        },
        onAwesomeUser() {
            this.$router.push({ path: "/account" });
            this.$emit("closeDrawer");
        },
        onLogOut() {
            this.$confirm("", "你確定登出嗎？\nAre you sure want to logout?", {
                confirmButtonText: "登出 Logout",
                cancelButtonText: "返回 Back",
                center: true,
                showClose: false,
                closeOnClickModal: false,
                customClass: "exit-box",
                cancelButtonClass: "exit-cancel",
                confirmButtonClass: "exit-confirm",
            })
                .then(() => {
                    this.logout();
                })
                .catch(() => {});
        },
        logout() {
            let form = {
                refreshToken: this.refreshToken,
            };
            logout(form)
                .then(() => {
                    removeToken();
                    removeAll();
                    window.sessionStorage.clear();
                    this.$router.push({ path: "/login" });
                })
                .catch(() => {
                    removeToken();
                    removeAll();
                    window.sessionStorage.clear();
                    this.$router.push({ path: "/login" });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.menu {
    height: 100%;
    width: 100%;
    text-align: left;
    font-size: 18px;
    line-height: 28px;
    background-color: white;
    text-align: center;
}
.menu-item {
    padding: 0.5rem;
    line-height: 2.25rem;
}
.parent .menu-item {
    line-height: 1.125rem;
}
.menu-user {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.el-divider {
    margin: 0;
}
.userInfo {
    width: 1.4rem;
    vertical-align: sub;
}
</style>
